import dayjs from 'dayjs';

export function formatDate(timestamp: string) {
  return dayjs(Number(timestamp) * 1000).format('hh:mm A, D MMM. YYYY');
}
